import React, { useEffect, useState } from 'react';
import './MobileMessage.css';

const MobileMessage = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isDismissed, setIsDismissed] = useState(false);

    useEffect(() => {
        const checkMobileDevice = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /Mobi|Android/i.test(userAgent);
        };

        const dismissed = localStorage.getItem('mobileBannerDismissed');
        setIsMobile(checkMobileDevice());
        setIsDismissed(dismissed === 'true');
    }, []);

    const handleDismiss = () => {
        localStorage.setItem('mobileBannerDismissed', 'true');
        setIsDismissed(true);
    };

    if (!isMobile || isDismissed) return null;
    
    return (
        <div className="mobile-message">
            <div className="message-content">
                <div id="unsupported-browser">
                    <button 
                        className="close-button" 
                        onClick={handleDismiss}
                        aria-label="Close"
                    >
                        ×
                    </button>
                    <h2>Unsupported Mobile Devices</h2>
                    <p>
                        We do not support the desktop version of the application on mobile devices.
                    </p>
                    <p>
                        Please download the application from one of the markets below:
                    </p>
                    <nav>
                        <ul>
                            <li className="google-play">
                                <a href="https://play.google.com/store/apps?hl=ru" target="_blank"
                                    rel="noopener noreferrer">
                                    <div className="image">
                                        <div className="text">Google Play</div>
                                    </div>
                                </a>
                            </li>
                            <li className="app-store">
                                <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
                                    <div className="image">
                                        <div className="text">App Store</div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default MobileMessage;
